module.exports = __webpack_public_path__ + "static/img/logo_25.8521d45.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo/logo_25.png
// module id = EYWV
// module chunks = 1